/** A single company entry from the peer chart JSON data. */
export interface PeerChartCompany {
  name: string;
  ticker: string;
  slug: string | null;
  isTarget: boolean;
  per: number | null;
  fwdPe: number | null;
  pbv: number | null;
  evFcf: number | null;
  roe: number | null;
  marketcapUsd: number | null;
}

/** Translated labels for the scatter chart, passed from the server. */
export interface ScatterLabels {
  title: string;
  xAxis: string;
  yAxis: string;
  medianRoe: string;
  medianFwdPe: string;
  quadrants: {
    value: string;
    growth: string;
    overvalued: string;
    cheap: string;
  };
}

/** A normalized valuation radar metric. */
export interface PeerRadarMetric {
  key: string;
  label: string;
  direction: "lower" | "higher";
  targetScore: number;
  peerAverageScore: number;
  targetFormatted: string;
  peerAverageFormatted: string;
  peerCoverage: number;
  uniform: boolean;
  note: string;
}

/** Chart-ready valuation radar payload. */
export interface PeerRadarData {
  status: "success" | "insufficient_peer_data" | "radar_unavailable";
  message: string;
  snapshotDate: string | null;
  peerCount: number;
  targetName?: string;
  targetTicker?: string;
  metrics: PeerRadarMetric[];
}

/** Full chart data embedded via json_script. */
export interface PeerChartData {
  companies: PeerChartCompany[];
  scatterLabels?: ScatterLabels;
  radarData?: PeerRadarData;
}

/** Shows a "no data" placeholder message inside a chart container. */
export function showChartEmptyState(
  container: HTMLElement,
  textColor: string,
  message: string,
): void {
  container.textContent = "";
  const wrapper = document.createElement("div");
  wrapper.className = "flex items-center justify-center h-full";
  const text = document.createElement("p");
  text.className = "text-sm";
  text.style.color = textColor;
  text.style.opacity = "0.6";
  text.textContent = message;
  wrapper.appendChild(text);
  container.appendChild(wrapper);
}
